import { SELF_CARE_MEDIA_EVENTS, SELF_CARE_MEDIA_EVENTS_PROPERTIES } from '../common/constants/mixpanelConstants'
import { ESSENTIALS_CONTENT_CATEGORY } from '../essentials/types'
import { SelfCareMediaContent } from '../selfCareMedia/types'

export const getDefaultAudioMixpanelProperties = (media: SelfCareMediaContent) => {
  return {
    [SELF_CARE_MEDIA_EVENTS_PROPERTIES.DESTINATION_URL]: media.articleSubPath,
    [SELF_CARE_MEDIA_EVENTS_PROPERTIES.CONTENT_ID]: media.id,
    [SELF_CARE_MEDIA_EVENTS_PROPERTIES.CONTENT_FORMAT]: media.contentFormat,
    [SELF_CARE_MEDIA_EVENTS_PROPERTIES.CONTENT_TYPE]: media.contentType,
    [SELF_CARE_MEDIA_EVENTS_PROPERTIES.ESSENTIALS]: true,
    [SELF_CARE_MEDIA_EVENTS_PROPERTIES.LIBRARY_NAME]: 'Essentials',
  }
}

export const getAudioPlayMixpanelProperties = (media: SelfCareMediaContent, duration: number) => {
  return {
    ...getDefaultAudioMixpanelProperties(media),
    [SELF_CARE_MEDIA_EVENTS_PROPERTIES.TITLE]: media.title,
    [SELF_CARE_MEDIA_EVENTS_PROPERTIES.URL_SLUG]: media.slug,
    [SELF_CARE_MEDIA_EVENTS_PROPERTIES.DURATION]: duration,
    [SELF_CARE_MEDIA_EVENTS_PROPERTIES.FROM_LYRA]: true,
  }
}

const getDiscoverMediaMixpanelProperties = (subPath: string) => {
  return {
    [SELF_CARE_MEDIA_EVENTS_PROPERTIES.DESTINATION_URL]: subPath,
  }
}

const getDefaultMixpanelPropertiesWithUrl = (subPath: string, media?: SelfCareMediaContent) => {
  return {
    ...(media ? getDefaultAudioMixpanelProperties(media) : {}),
    [SELF_CARE_MEDIA_EVENTS_PROPERTIES.DESTINATION_URL]: subPath,
  }
}

export const getNavigateToEssentialMixpanelProperties = (
  event: SELF_CARE_MEDIA_EVENTS,
  subPath: string,
  media?: SelfCareMediaContent,
) => {
  switch (event) {
    case SELF_CARE_MEDIA_EVENTS.CLICK_DISCOVER: {
      return getDiscoverMediaMixpanelProperties(subPath)
    }
    case SELF_CARE_MEDIA_EVENTS.CLICK_ESSENTIALS_VIDEO:
    case SELF_CARE_MEDIA_EVENTS.CLICK_SHOW_TRANSCRIPT: {
      return getDefaultMixpanelPropertiesWithUrl(subPath, media)
    }
  }

  return {}
}

export const getExploreMoreEssentialSubPath = ({
  slug,
  category = ESSENTIALS_CONTENT_CATEGORY.ARTICLE,
}: {
  slug?: string
  category?: ESSENTIALS_CONTENT_CATEGORY
}) => {
  const categoryStr = `${category}s`
  return slug ? `/${categoryStr}/${slug}` : ''
}
